import React from 'react';
import { Navigate } from 'react-router-dom';

const ProtectedByLevel = ({ 
  children, 
  niveisPermitidos = [], 
  showMessage = true, // compatibilidade com uso interno (esconder elemento)
  redirect = true,    // se false, apenas oculta sem redirecionar
}) => {
  // Ler direto do localStorage (síncrono, sem race condition)
  const token = localStorage.getItem('token');
  const userStr = localStorage.getItem('user');
  
  if (!token || !userStr) {
    return redirect ? <Navigate to="/login" replace /> : null;
  }

  try {
    const userData = JSON.parse(userStr);
    const nivel = userData?.nivel_acesso || userData?.usuario?.nivel_acesso;
    
    if (nivel && niveisPermitidos.includes(nivel)) {
      return children;
    }
  } catch {}

  // Sem permissão
  // Se showMessage=false (uso interno) apenas oculta, não redireciona
  if (!showMessage || !redirect) return null;
  
  return <Navigate to="/" replace />;
};

export default ProtectedByLevel;
